module.exports = __webpack_public_path__ + "media/images/suceess-story1-feb4a054953455b65ed09fc74c077df7.jpg";